import axiosInstance from "@/api/axiosInstance";
import { CompanyHealthData } from "@/modules/coaching/types";

export interface GetCoachCompaniesParams {
  sortBy?: 'health' | 'lastEngagement' | 'companyName' | 'reminders';
  filterBy?: 'all' | 'needsAttention' | 'noRecentEngagement';
  searchQuery?: string;
  limit?: number;
  offset?: number;
}

export interface GetCoachCompaniesResponse {
  companies: CompanyHealthData[];
  total: number;
  limit: number;
  offset: number;
}

export const getCoachCompanies = async (
  params?: GetCoachCompaniesParams
): Promise<GetCoachCompaniesResponse> => {
  const response = await axiosInstance.get('/api/private/coaching/companies', {
    params
  });
  return response.data;
};
